import { Box, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import patterns from '../../../assets/imgs/pattens/pattern1.png';
import {
  KC_SEARCH_PATH,
  getHeroConfig,
  getStats,
} from '../repository';
import { KC_COLORS } from '../theme';
import { KcIcon } from './KcIcon';

export function KnowledgeCenterHero({
  initialQuery = '',
  showTitle = true,
  showSubtitle = true,
  showStats = true,
  inputId = 'kc-search',
}) {
  const navigate = useNavigate();
  const [query, setQuery] = useState(initialQuery);
  const hero = getHeroConfig();
  const stats = getStats();

  useEffect(() => {
    setQuery(initialQuery);
  }, [initialQuery]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const nextQuery = query.trim();
    const search = nextQuery ? `?q=${encodeURIComponent(nextQuery)}` : '';
    navigate(`${KC_SEARCH_PATH}${search}`);
  };

  return (
    <Box
      className="w-full pt-36 md:pt-44 pb-12 md:pb-14"
      sx={{
        backgroundColor: KC_COLORS.primaryNavy,
        backgroundImage: `url(${patterns})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom center',
        backgroundSize: 'cover',
      }}
    >
      <Container maxWidth="lg">
        <Box className="w-full max-w-5xl mx-auto text-center text-white px-2">
          {showTitle ? (
            <h1
              className="kc-hero-title m-0"
              style={{
                color: '#FFFFFF',
                fontSize: 'clamp(28px, 4vw, 42px)',
                lineHeight: 1.2,
                fontWeight: 600,
                letterSpacing: '0.5px',
              }}
            >
              {hero.titleBefore}
              <span style={{ color: KC_COLORS.teal }}>{hero.titleHighlight}</span>
              {hero.titleAfter}
            </h1>
          ) : null}

          {showSubtitle ? (
            <p
              className="kc-hero-subtitle m-0 mt-5 md:mt-6 max-w-2xl mx-auto"
              style={{
                color: 'rgba(255,255,255,0.88)',
                fontSize: '16px',
                lineHeight: '24px',
              }}
            >
              {hero.subtitle}
            </p>
          ) : null}

          <form
            onSubmit={handleSubmit}
            className={`kc-hero-search ${showTitle || showSubtitle ? 'mt-8 md:mt-10' : ''}`}
          >
            <label htmlFor={inputId} className="sr-only">
              Search the Knowledge Center
            </label>
            <div className="relative w-full max-w-3xl mx-auto">
              <input
                id={inputId}
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder={hero.searchPlaceholder}
                className="w-full h-14 md:h-[60px] rounded-full bg-white pl-6 md:pl-7 pr-14 md:pr-16 shadow-[0_10px_30px_rgba(0,0,0,0.18)] outline-none focus:ring-2"
                style={{
                  color: KC_COLORS.primaryNavy,
                  fontSize: '15px',
                  lineHeight: '22px',
                  '--tw-ring-color': KC_COLORS.teal,
                }}
              />
              <button
                type="submit"
                aria-label="Search"
                className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 md:w-11 md:h-11 rounded-full text-white flex items-center justify-center transition-opacity hover:opacity-90"
                style={{ backgroundColor: KC_COLORS.teal }}
              >
                <KcIcon name="search" fontSize="small" />
              </button>
            </div>
          </form>

          {showStats ? (
            <div className="kc-hero-stats mt-8 md:mt-10 w-full">
              <div className="kc-hero-stats-row">
                {stats.map((stat) => (
                  <div
                    key={stat.id}
                    className={`kc-hero-stat${stat.value ? '' : ' kc-hero-stat--wide'}`}
                  >
                    <span
                      className="kc-hero-stat-icon inline-flex shrink-0 items-center justify-center w-10 h-10 rounded-full"
                      style={{
                        backgroundColor: 'rgba(0,155,170,0.18)',
                        color: KC_COLORS.teal,
                        border: '1px solid rgba(0,155,170,0.45)',
                      }}
                    >
                      <KcIcon
                        name={stat.icon}
                        fontSize="small"
                        sx={{ fontSize: 22 }}
                      />
                    </span>

                    <div className="kc-hero-stat-copy text-left min-w-0">
                      {stat.value ? (
                        <>
                          <div
                            className="kc-hero-stat-value"
                            style={{
                              color: '#FFFFFF',
                              fontSize: '18px',
                              lineHeight: '22px',
                              fontWeight: 700,
                            }}
                          >
                            {stat.value}
                          </div>
                          <div
                            className="kc-hero-stat-label"
                            style={{
                              color: 'rgba(255,255,255,0.82)',
                              fontSize: '13px',
                              lineHeight: '18px',
                              fontWeight: 400,
                              marginTop: 2,
                            }}
                          >
                            {stat.label}
                          </div>
                        </>
                      ) : (
                        <div
                          className="kc-hero-stat-label"
                          style={{
                            color: 'rgba(255,255,255,0.9)',
                            fontSize: '13px',
                            lineHeight: '18px',
                            fontWeight: 500,
                          }}
                        >
                          {stat.labelBefore ? (
                            <>
                              <span style={{ fontWeight: 400 }}>
                                {stat.labelBefore}{' '}
                              </span>
                              <span
                                style={{ fontWeight: 700, color: '#FFFFFF' }}
                              >
                                {stat.label}
                              </span>
                            </>
                          ) : (
                            stat.label
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </Box>
      </Container>
    </Box>
  );
}
